import React, { useEffect, useState } from "react";
import "../Pages/card.scss";
import Card from "../Components/Card";
import { TagButton, TagButtonAll } from "../Components/TagButtons";
import studio from "../assets/Genesis/01.jpg";
import hallway from "../assets/Genesis/010.jpg";
import bathroom from "../assets/Genesis/013.jpg";
import plan from "../assets/Genesis/plan.jpg";

import flat from "../Components/data.json";
import { useCallback } from "react";
import Gallery from "../Components/GalleryViewer";
import { Translation } from "react-i18next";

const images = flat;

const studioCardsData = [
  {
    img: studio,
    alt: "studio",
    titleKey: "portfolio.title-21",
    descKey: "portfolio.description-21",
    tagName: "студия",
  },
  {
    img: hallway,
    alt: "hallway",
    titleKey: "portfolio.title-8",
    descKey: "portfolio.description-8",
    tagName: "прихожая",
  },
  {
    img: bathroom,
    alt: "bathroom",
    titleKey: "portfolio.title-6",
    descKey: "portfolio.description-6",
    tagName: "ванная",
  },
  {
    img: plan,
    alt: "plan",
    titleKey: "portfolio.title-11",
    descKey: "portfolio.description-11",
    tagName: "планировка",
  },
];

function FlatSeven() {
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  useEffect(() => {
    tag === "all"
      ? setFilteredImages(images.flat_7)
      : setFilteredImages(images.flat_7.filter((image) => image.tag === tag));
  }, [tag]);

  useEffect(() => {
    if (isViewerOpen) {
      document.body.classList.add("viewer-open");
    } else {
      document.body.classList.remove("viewer-open");
    }
  }, [isViewerOpen]);

  return (
    <Translation>
      {(t) => (
        <div
          style={{
            fontWeight: "bold",
            fontFamily: "Montserrat, sans-serif",
            textAlign: "center",
            color: "#46669c",
          }}
        >
          <h5
            style={{ fontWeight: "600", marginLeft: "1em", marginRight: "1em" }}
          >
            {t(["portfolio.adres-7"])}
            {/*    Visualization of the interior of the house. Krivoy Rog, Kobylyanska
            str. */}
          </h5>
          <div className="wrapper mt-4">
            {studioCardsData.map((card, index) => (
              <div
                className="card"
                key={index}
                style={{ fontFamily: "Montserrat, sans-serif" }}
              >
                <Card
                  img={card.img}
                  alt={card.alt}
                  title={t([card.titleKey])}
                  description={t([card.descKey])}
                />
                <div onClick={() => openImageViewer(0)}>
                  <TagButton
                    name={card.tagName}
                    tagactive={tag === card.tagName}
                    handleSetTag={setTag}
                  />
                </div>
              </div>
            ))}
          </div>

          <div onClick={() => openImageViewer(0)}>
            <TagButtonAll
              name="all"
              tagactive={tag === "all" ? true : false}
              handleSetTag={setTag}
            />
          </div>

          <div>
            {isViewerOpen && (
              <Gallery
                images={filteredImages}
                startIndex={currentImage}
                onClose={closeImageViewer}
              />
            )}
          </div>
        </div>
      )}
    </Translation>
  );
}

export default FlatSeven;
